const items = [
  // Page 1

 // Row 1
  {
    image: "/assets/corsets/corset1.jpg",
    description: "Silk satin bias gown",
  },
  {
    image: "/assets/corsets/corset1a.jpg",
    description: "Calais Lace gown",
  },
  {
    image: "/assets/corsets/corset1b.jpg",
    description: "Silk organza bow",
  },

  // Row 2
  {
    image: "/assets/corsets/corset2.jpg",
    description: "Silk satin bias gown",
  },
  {
    image: "/assets/corsets/corset2a.jpg",
    description: "Calais Lace gown",
  },
  {
    image: "/assets/corsets/corset2b.jpg",
    description: "Silk organza bow",
  },

  // Row 3
  {
    image: "/assets/corsets/corset3.jpg",
    description: "Silk satin bias gown",
  },
  {
    image: "/assets/corsets/corset3a.jpg",
    description: "Calais Lace gown",
  },
  {
    image: "/assets/corsets/corset3b.jpg",
    description: "Silk organza bow",
  },

  // Row 4
  {
    image: "/assets/corsets/corset4.jpg",
    description: "Silk satin bias gown",
  },
  {
    image: "/assets/corsets/corset4a.jpg",
    description: "Calais Lace gown",
  },
  {
    image: "/assets/corsets/corset4b.jpg",
    description: "Silk organza bow",
  },

  // Row 5
  {
    image: "/assets/corsets/corset5.jpg",
    description: "Silk organza bow",
  },
  {
    image: "/assets/corsets/corset5a.jpg",
    description: "Silk organza bow",
  },
  {
    image: "/assets/corsets/corset5b.jpg",
    description: "Silk organza bow",
  },

  // Row 6
  {
    image: "/assets/corsets/corset6.jpg",
    description: "Calais Lace gown",
  },
  {
    image: "/assets/corsets/corset6a.jpg",
    description: "Calais Lace gown",
  },
  {
    image: "/assets/corsets/corset6b.jpg",
    description: "Silk organza bow",
  },

  // Row 7
  {
    image: "/assets/corsets/corset7.jpg",
    description: "Silk satin bias gown",  
  },
];


export default items;